module.exports = __webpack_public_path__ + "img/image01.68152e2c.jpg";